module.exports = __webpack_public_path__ + "img/eyes_male_asian_average_mask.06a06bc6.png";